import { BrowserModule, Title, HAMMER_GESTURE_CONFIG, HammerModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NoCacheHeadersInterceptor } from "./interceptors/no-cache-headers-interceptor";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { AuthService } from "./auth/services/auth.service";
import { CheckTokenInterceptor } from "./interceptors/check-token.interceptor";
import { HttpErrorInterceptor } from "./interceptors/http-error.interceptor";
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from "@angular/material/snack-bar";
import { SideNavbarComponent } from "./components/side-navbar/side-navbar.component";
import { NgCircleProgressModule } from "ng-circle-progress";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { DatePipe } from "@angular/common";
import { LyHammerGestureConfig, StyleRenderer, LyTheme2, LY_THEME_NAME, LY_THEME, LyThemeModule } from "@alyle/ui";
import { MinimaLight } from '@alyle/ui/themes/minima';

@NgModule({
  declarations: [
    AppComponent,
    // DashboardComponent,
    SideNavbarComponent,
    // DargDropReferralDirective,
    // DragAndDropDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    }),
    HammerModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CheckTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: MAT_SNACK_BAR_DATA,
      useValue: {},
    },
    {
      provide: MatSnackBarRef,
      useValue: {},
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: "en-GB",
    },
    AuthService,
    { provide: HAMMER_GESTURE_CONFIG, useClass: LyHammerGestureConfig },
    StyleRenderer,
    LyTheme2,
    { provide: LY_THEME_NAME, useValue: 'minima-light' },
    { provide: LY_THEME, useClass: MinimaLight, multi: true }, // name: `minima-light`
    Title,
    DatePipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
